import { Button } from "antd"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { useLocation } from "react-router"

import { languages } from "../../../lib/languages"
import { flushError } from "../../../services/verify/actions"
import { buttonLayout } from "../../../styles/constants"
import { Card } from "../../new/Card/Card"
import { FormPage } from "../../new/Form/Form"
import useOurForm from "../../new/Form/useForm"
import styles from "./Verify.module.scss"

// Code entry screen for the login 2FA triggered when a patient retrieves
// its account by NIR/phone. The phone displayed here is masked by the API.
const LoginVerifyComponent = (props: any): any => {
  const formRef = useOurForm()
  const location = useLocation()

  const onSubmit = (event: any) => {
    props.flush(location.pathname)
    props.onSubmit(event.code)
  }

  const onResend = () => {
    props.flush(location.pathname)
    formRef.reset(["code"])
    props.onResend()
  }

  const label = (
    <div>
      {languages.writeVerifyCode()}{" "}
      <span className={styles.Phone}>{props.phone}</span>
    </div>
  )

  useEffect(() => {
    if (props.error && Object.keys(props.error).length) {
      formRef.reset(["code"])
    }
  }, [props.error])

  const inputsObj = [{ name: "code", required: true, label, autoSubmit: true }]
  return (
    <Card message={props.error?.[location.pathname] ? props.error[location.pathname].text?.message : props.error}>
      <FormPage
        formRef={formRef}
        inputs={inputsObj}
        loading={props.loading}
        acceptButton=""
        onFinish={(e: any) => {
          onSubmit(e)
          setTimeout(() => { formRef.reset(["code"]) }, 6000)
        }}
        onValuesChange={() => { }}
        onCancel={props.onCancel}
      />
      <div className="wrapped-buttons space-around" style={{ margin: 0 }}>
        <Button {...buttonLayout} onClick={onResend}>
          {languages.resend_code}
        </Button>
      </div>
      <div
        className="wrapped-buttons space-around"
        style={{ marginTop: 25, marginBottom: 25 }}
      >
        <span className={styles.ContactSecretary}>
          {languages.contact_secretary}
        </span>
      </div>
    </Card>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    flush: (location: string) => dispatch(flushError({ path: location })),
  }
}
export default connect(null, mapDispatchToProps)(LoginVerifyComponent)
